import api from "./api";

// Some list endpoints come back with $values wrapping (Newtonsoft
// PreserveReferencesHandling) — same pattern your other services already
// unwrap, applied here too.
const unwrapArray = (val) => val?.$values ?? val ?? [];

export const registerReferrer = async () => {
  const res = await api.post("/referrer/register");
  return res.data?.data ?? null;
};

// Returns null (not a throw) when the user has no referrer profile yet —
// the calling code decides what to do with that (e.g. show onboarding).
export const getReferrerMe = async () => {
  try {
    const res = await api.get("/referrer/me");
    return res.data?.data ?? null;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};

export const getMyReferrals = async () => {
  const res = await api.get("/referrer/me/referrals");
  return unwrapArray(res.data?.data);
};

export const getMyEarnings = async () => {
  const res = await api.get("/referrer/me/earnings");
  const data = res.data?.data;
  if (!data) return { totalPaid: 0, totalPending: 0, commissions: [] };
  return { ...data, commissions: unwrapArray(data.commissions) };
};
